// Known aliases: DB system name (normalized) → Glue job name (normalized)
const JOB_NAME_ALIASES: Record<string, string> = {
    'sapsuccessfactors': 'successfactors',
}

/**
 * Check whether a system has at least one matching Glue schedule.
 * Mirrors backend logic in _trigger_raw_stage.
 */
export function systemHasSchedule(entityName: string, systemName: string, systemAbbr: string | undefined, schedules: any[]): boolean {
    const entityLower = entityName.toLowerCase()
    const candidates = [systemName.toLowerCase()]
    if (systemAbbr) candidates.push(systemAbbr.toLowerCase())

    for (const schedule of schedules) {
        for (const jobAction of (schedule.job_actions || [])) {
            const args = jobAction.arguments || {}
            const jobEntity = (args['--entity_name'] || args['--entity_system'] || '').toLowerCase()
            if (jobEntity !== entityLower) continue

            const hasSystemArg = !!args['--system_name']
            if (hasSystemArg) {
                // Generic ETL: --system_name is explicit, exact match
                const jobSystem = args['--system_name'].toLowerCase()
                if (candidates.some(c => c === jobSystem)) return true
            } else {
                // Non-generic ETL: job name IS the system (e.g., "successfactors2s3-high-performance")
                // Strip "-high-performance" and "2s3" suffixes, normalize hyphens/spaces, compare exactly
                const jobName = (jobAction.job_name || '').toLowerCase().replace(/-high-performance$/, '').replace(/2s3$/, '').replace(/[-\s]/g, '')
                if (candidates.some(c => {
                    const cNorm = c.replace(/[-\s]/g, '')
                    const resolved = JOB_NAME_ALIASES[cNorm] || cNorm
                    return resolved === jobName
                })) return true
            }
        }
    }
    return false
}
